// HEAL-76 §4.3 — колокольчик со счётчиком непрочитанных.
//
// Число берётся из профиля (D-7): этот запрос и так лежит на старте приложения,
// и отдельный опрос раз в N секунд ради двух уведомлений в неделю знал бы не
// больше, а стоил бы дороже.
//
// Стоит только на Главной — это экран, на который человек возвращается, и одной
// точки входа достаточно.

import { useLocation } from 'wouter';
import { Bell } from 'lucide-react';
import { useProfileMe } from '@/api/hooks/profile';

export function NotificationsBell() {
  const [, setLocation] = useLocation();
  const profile = useProfileMe();

  const unread = profile.data?.meta.unread_notifications ?? 0;

  return (
    <button
      type="button"
      onClick={() => setLocation('/notifications')}
      aria-label={unread > 0 ? `Уведомления, непрочитанных: ${unread}` : 'Уведомления'}
      className="relative flex h-9 w-9 items-center justify-center rounded-full hover-elevate active-elevate-2"
    >
      <Bell className="h-5 w-5" />

      {/* При нуле бейджа нет вовсе: пустой кружок читается как «что-то не так». */}
      {unread > 0 && (
        <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-hl-small font-semibold leading-none text-white">
          {unread > 9 ? '9+' : unread}
        </span>
      )}
    </button>
  );
}
